export const ready = () => {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('collection-info-tabs.ready');
};

export const publish = ({ itemText = '', stash = false, append = '' } = {}) => {
  const opts = {
    stash,
    category: 'tab',
    pageType: 'collections:list view',
    linkText: `${append}${itemText}`.toLowerCase()
  };
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('tabbed-links.click', opts);
  }
};
